module.exports = __webpack_public_path__ + "img/kangaroo.be5030ca.webp";